import type { SVGProps } from "react";

const DragGripIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    aria-hidden="true"
  >
    {[3, 8, 13].map((cy) => (
      <g key={cy}>
        <circle cx="4" cy={cy} r="1.25" fill="currentColor" />
        <circle cx="10" cy={cy} r="1.25" fill="currentColor" />
      </g>
    ))}
  </svg>
);

export default DragGripIcon;
